<script>
import bus from '@/js/util/disclosure';

export default {
    name: 'DisclosureContainer',
    props: {
        id: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            default: 'div',
        },
        transition: {
            type: String,
            default: 'transition',
        },
        transitionProps: {
            type: Object,
            default: () => ({}),
        },
        mode: {
            type: String,
            default: 'show',
            validate(value) {
                return ['if', 'show'].includes(value);
            },
        },
    },
    data() {
        return {
            expanded: undefined,
        };
    },
    created() {
        bus.$on('toggle', this.toggle);
        bus.$emit('created:container', this.id);
    },
    methods: {
        toggle({ controls, expanded }) {
            if (controls.split(' ').includes(this.id)) {
                this.expanded = expanded;
            }
        },
    },
    render(createElement) {
        const data = {
            attrs: {
                id: this.id,
            },
        };

        if (this.mode === 'show') {
            data.directives = [{
                name: 'show',
                value: this.expanded,
            }];
        }

        const el = this.mode === 'show' || this.open
            ? createElement(this.tag, data, this.$slots.default) : undefined;
        if (this.transition) {
            return createElement(
                this.transition,
                { props: this.transitionProps },
                [el],
            );
        }

        return el;
    },
};
</script>



// WEBPACK FOOTER //
// src/components/disclosure/DisclosureContainer.vue